/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 회사/사업장/세부사업장 개발
 *
 ********************************************************************/
import React from "react";
//component
import SubZoneView from "./SubZoneView";
import SubZoneInsert from "./SubZoneInsert";
import SubZoneUpdate from "./SubZoneUpdate";
/**
 * @brief EHP 사업장 전기실 관리 - 상세 사업장 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
function AdminSubZone(props) {
    //const [isMobile, setIsMobile] = useState(false);
    //const [adminType, setAdminType] = useState("ZONE"); // ZONE, SUBZONE, ROOM
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const curTree = props.curTree;
    const setParentCurTree = props.setCurTree;
    const workMode = props.workMode;
    /*
      const [curTree, setCurTree] = useState({
        company:{companyId:"", companyName:""},
        zone:{zoneId:"", zoneName:""},
        subZone:{subZoneId:"", subZoneName:""},
        room:{roomId:"", roomName:""},
        spg:{spgId:-1, spgName:""}
      });
    
    
      function handleCurTree(adminType, treeInfo) {
        clog("IN SITETREE : handleCurTree : " + adminType);
        setParentAdminType(adminType);
        setCurTree(treeInfo);
      }
    */
    //clog("IN ADMINSUBZONE : INIT : " + isMobile + " : adminType : " + adminType + " : workMode : " + workMode + " : " + JSON.stringify(curTree));
    return (React.createElement(React.Fragment, null,
        (workMode === "READ") && React.createElement(SubZoneView, { curTree: curTree, isMobile: props.isMobile, setIsMobile: props.setIsMobile, setCurTree: props.setCurTree, setAdminType: props.setAdminType, setWorkMode: props.setWorkMode, setCurTabMenu: props.setCurTabMenu, setPopWin: props.setPopWin }),
        (workMode === "CREATE") && React.createElement(SubZoneInsert, { curTree: curTree, isMobile: props.isMobile, setIsMobile: props.setIsMobile, setCurTree: props.setCurTree, setAdminType: props.setAdminType, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin }),
        (workMode === "UPDATE") && React.createElement(SubZoneUpdate, { curTree: curTree, isMobile: props.isMobile, setIsMobile: props.setIsMobile, setCurTree: props.setCurTree, setAdminType: props.setAdminType, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin })));
}
;
export default AdminSubZone;
